<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>老师管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">


      <!-- <el-form-item>
        <el-select size="small" v-model="type" @change="selectSlideshow()" placeholder="请选择">
          <el-option v-for="type in typeArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->



      <el-form-item label="">

        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="name" label="老师头像" width="100">
        <template slot-scope="scope">
          <img class="tech-avatar" style="width: 50px; height: 50px;" :src="scope.row.headPortrait">
        </template>
      </el-table-column>
      <el-table-column sortable prop="name" label="姓名" width="120"> </el-table-column>
      <el-table-column sortable prop="business" label="从业" width="120"> </el-table-column>
      <el-table-column sortable prop="mainTeach" label="主要教学" width="120"> </el-table-column>
      <el-table-column sortable prop="introduce" label="介绍" width="400"> </el-table-column>





      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">


          <el-button size="mini" @click="handleEditIsData(scope.$index, scope.row)">资料管理</el-button>
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteTeacher(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="danger" @click="getCode(scope.$index, scope.row)">查看二维码</el-button>


          
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">


        <el-form-item label="主图" style="">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="formData.headPortrait" :src="formData.headPortrait" class="avatar">
          </div>
          <el-progress v-if="uploadProgress.show" :percentage="uploadProgress.percent" style="margin-top: 10px; width: 148px;"></el-progress>

        </el-form-item>


        <el-form-item label="姓名" prop="name" style="margin-bottom: 50px;">
          <!-- <el-input size="small" v-model="formData.name" auto-complete="off" placeholder="姓名"></el-input> -->
          <quill-editor v-model="formData.name" :options="editorOption" style="height: 200px;"
                        ref="QuillEditor">
                    </quill-editor>
        </el-form-item>

        <el-form-item label="从业" prop="business" style="margin-bottom: 50px;">
          <!-- <el-input size="small" v-model="formData.business" auto-complete="off" placeholder="从业"></el-input> -->
          <quill-editor v-model="formData.business" :options="editorOption" style="height: 200px;"
                        ref="QuillEditor">
                    </quill-editor>
        </el-form-item>
        <el-form-item label="主要教学" prop="mainTeach" style="margin-bottom: 50px;">
          <!-- <el-input size="small" v-model="formData.mainTeach" auto-complete="off" placeholder="主要教学"></el-input> -->
          <quill-editor v-model="formData.mainTeach" :options="editorOption" style="height: 200px;"
                        ref="QuillEditor">
                    </quill-editor>
        </el-form-item>
        <el-form-item label="介绍" prop="introduce" style="margin-bottom: 50px;">
          <!-- <el-input size="small" v-model="formData.introduce" auto-complete="off" placeholder="介绍"></el-input> -->

          <quill-editor v-model="formData.introduce" :options="editorOption" style="height: 200px;"
                        ref="QuillEditor">
                    </quill-editor>
        </el-form-item>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="addTeacher()"
          v-if="title == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upTeacher()"
          v-if="title == '修改'">修改</el-button>
      </div>
    </el-dialog>















    <el-dialog title="资料管理" :visible.sync="isData" width="50%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" title="" border
        element-loading-text="拼命加载中" style="width: 100%;">

        <el-table-column prop="id" label="id" width="60"></el-table-column>
        <el-table-column prop="title" label="标题" width="200"></el-table-column>

        <el-table-column prop="dataType" label="标签" width="200"></el-table-column>
        <el-table-column prop="type" label="类型" width="200"></el-table-column>


        <el-table-column prop="name" label="封面图" width="120">

          <template slot-scope="scope">
            <img style="width: 90px;height: 90px;" :src="scope.row.image">
          </template>

        </el-table-column>

        


        <el-table-column prop="createTime" label="创建时间" width="200">
          <template slot-scope="scope">
            <div>{{ transformDate(scope.row.createTime) }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
       </el-table-column> -->
        <el-table-column align="center" label="操作" min-width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditDataData(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click='deleteTeacherData(scope.row)'>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-form :inline="true" :model="formInline">


        <el-form-item>

          <el-button size="small" type="primary" class="title" @click="editFormVisibleData = true">添加</el-button>

        </el-form-item>

      </el-form>
    </el-dialog>











    <!-- 编辑界面 -->
    <el-dialog :title="courseDataTitle" :visible.sync="editFormVisibleData" width="80%" @click="closeDialog">
      <el-form label-width="120px" ref="editForm">
        <el-form-item label="标题" prop="deptName">
          <el-input size="small" v-model="formDataData.title" auto-complete="off" placeholder="请输入标题"></el-input>
        </el-form-item>


        <el-form-item label="标签" prop="deptName">
          <el-input size="small" v-model="formDataData.dataType" auto-complete="off" placeholder="请输入标签，如：日常"></el-input>
        </el-form-item>

        <el-form-item label="类型，0图文，1视频" prop="deptName">
          <el-input size="small" v-model="formDataData.type" auto-complete="off" placeholder="请输入，0图文，1视频"></el-input>
        </el-form-item>

        


        <el-form-item label="封面图" style="">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload1" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="formDataData.image" :src="formDataData.image" class="avatar">

          </div>

        </el-form-item>



        <el-form-item label="视频" style="" v-if="formDataData.type==1">

          <div class="upload-demo">
            <el-upload action="" :http-request="mainImgUpload2" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>

          <div>{{ formDataData.content }}</div>

        </el-form-item>


        
        <el-form-item label="图文" style="" v-if="formDataData.type==0">

          <quill-editor
              v-model="formDataData.content"
              :options="editorOption"
              style="height: 200px;"
              ref="QuillEditor">
          </quill-editor>

        </el-form-item>
   



      </el-form>
      <div slot="footer" class="dialog-footer">

        <el-button size="small" type="primary" :loading="loading" class="title" @click="addTeacherData()"
          v-if="title == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upTeacherData()"
          v-if="title == '修改'">修改</el-button>
      </div>
    </el-dialog>







    <!--    自定义上传组件-->
    <el-dialog
      title="选择图片"
      :visible.sync="uploadVisible"
      width="30%">
      <div>
        

           <div class="upload-demo">
                  <el-upload
                  action=""
                  :http-request="mainImgUpload3"
                  :show-file-list="false"
                  list-type="picture-card" >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <img v-if="formData.mainImg" :src="formData.mainImg" class="avatar"> -->
     
            </div>



      </div>

    </el-dialog>





    <!--    自定义上传组件-->
    <el-dialog
      title="二维码图片"
      :visible.sync="qrcodeUploadVisible"
      width="30%">


      <div style="width: 300px; height: 300px;">    <div  ref="qrcodejs2" ></div>  </div>

    </el-dialog>



   


  </div>
</template>

<script>
import {

  addTeacher,
   upTeacher,
deleteTeacher,
getTeacherList,
addTeacherData, 
upTeacherData,
 deleteTeacherData,
 getTeacherDataList,





} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import client from "@/utils/ossClient.js";


// 引入 qrcodejs2
import QRCode from 'qrcodejs2';
 



import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"], // 对于图片上传这是重点
  ["clean"], // remove formatting button
];



export default {
  data() {
    return {
      qrcodeUploadVisible:false,
      cursorIndex: 0,
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: (value) => {
                if (value) {
                  // 在这里编写图片按钮点击操作
                  this.uploadVisible = true;
                  this.cursorIndex =
                    this.$refs.QuillEditor.quill.getSelection().index;
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      uploadVisible: false,



      type: 0,
      typeArr: [
        { key: '视频区域', value: 0 },
        { key: '直播区域', value: 1 },
        { key: '首页', value: 2 }
      ],
      isData: false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      editFormVisibleData:false,
      title: "添加",

      listData: [], //
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },


      formData: {
        name: "",
        headPortrait:"",
        business: "",
        mainTeach: "",
        introduce: ""
      },
      uploadProgress: { show: false, percent: 0 },


      
      formDataData: {
        id: "",
        title:"",
        teacherId:"",//老师ID
        dataType:"",//资料类型标签
        type:"",//'0图文，1视频',
        image:"",//'图片',
        content:"",//内容
      },
      qrcode: null

 
    };
  },
  // 注册组件
  components: {
    Pagination,
    VueQuillEditor
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {


    this.getTeacherList()





  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    getCode(index,item){

      console.log(123,item)
      console.log(QRCode)
      this.qrcodeUploadVisible = true;

      var self = this;
      


      setTimeout(() => {
        

                  // 创建二维码
        self.qrcode = new QRCode(self.$refs.qrcodejs2, {
          text: 'https://smilingly.huike996.com/#/pages/teacherIntroduction/teacherIntroduction?id='+item.id,
          width: 150,
          height: 150
        })


      }, 300);

    },

    //自定义上传方法..
    mainImgUpload3(file) {
      var self = this;
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            console.log("2222222", res);
            self.getUrl(res.url);
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => {});
    },


    getUrl(url) {
      this.uploadVisible = false;
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      if (url) {
        // 插入图片，res为服务器返回的图片链接地址

        quill.insertEmbed(this.cursorIndex, "image", url);
        // 调整光标到最后
        quill.setSelection(this.cursorIndex + 1);
      } else {
        // 提示上传失败信息
      }
    },




    // 删除
    deleteTeacher(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTeacher({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getTeacherList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //修改轮播图
    upTeacher() {

      this.loading = true;
      var formData = JSON.parse(JSON.stringify(this.formData));


      upTeacher(formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getTeacherList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //添加轮播图
    addTeacher() {

      this.loading = true;

      var formData = JSON.parse(JSON.stringify(this.formData))




      addTeacher(this.formData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisible = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getTeacherList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //自定义上传方法..
    mainImgUpload(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const fileName = file.file.uid + "." + exname;
      
      this.uploadProgress.show = true;
      this.uploadProgress.percent = 0;
      
      client
        .put(fileName, file.file, {
          progress: (p) => {
            this.uploadProgress.percent = Math.round(p * 100);
          }
        })
        .then((res) => {
          if (res.url) {
            this.formData.headPortrait = res.url;
            setTimeout(() => { this.uploadProgress.show = false; }, 1000);
          } else {
            this.$message.error("文件上传失败");
            this.uploadProgress.show = false;
          }
        })
        .catch((err) => { 
          this.uploadProgress.show = false;
        });
    },


    // 获取轮播图
    getTeacherList() {
      this.loading = true;

      getTeacherList().then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    // 分页插件事件
    callFather(parm) {
      this.getDishesList(parm.currentPage);
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.formData.id = row.id;
        this.formData.name = row.name;
        this.formData.business = row.business;
        this.formData.mainTeach = row.mainTeach;
        this.formData.introduce = row.introduce;
        this.formData.headPortrait = row.headPortrait;
        
      } else {
        this.title = "添加";
        this.formData.id = "";
        this.formData.name = "";
        this.formData.business = "";
        this.formData.mainTeach = "";
        this.formData.introduce = "";
        this.formData.headPortrait = "";
      }


    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
















    //显示编辑界面
    handleEditIsData: function (index, row) {
      this.isData = true;
      this.formDataData.teacherId = row.id;
      this.getTeacherDataList(row.id)
    },
    // 获取资料数据列表
    getTeacherDataList(teacherId) {
      this.loading = true;

      getTeacherDataList({  teacherId: teacherId }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.list;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
      


    //显示编辑界面
    handleEditDataData: function (index, row) {
      this.editFormVisibleData = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.formDataData.id = row.id;
        this.formDataData.teacherId = row.teacherId;
        this.formDataData.title = row.title;
        this.formDataData.dataType = row.dataType;
        this.formDataData.type = row.type;
        this.formDataData.image = row.image;
        this.formDataData.content = row.content;

        
        
      } else {
        this.title = "添加";
        this.formDataData.id = "";
        this.formDataData.teacherId = "";
        this.formDataData.title = "";
        this.formDataData.dataType = "";
        this.formDataData.type = "";
        this.formDataData.image = "";
        this.formDataData.content = "";
      }


    },



    //自定义上传方法..
    mainImgUpload1(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {

            this.formDataData.image = res.url;
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },







    //自定义上传方法..
    mainImgUpload2(file) {

      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      // const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      // if (names.indexOf(exname) < 0) {
      //   this.$message.error("不支持的格式!");
      //   return;
      // }

      
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          console.log(res)
          if (res.url) {

            this.formDataData.content = res.url;

            this.formDataData = JSON.parse(JSON.stringify(this.formDataData))
            
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },





    deleteTeacherData(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTeacherData({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getTeacherDataList(this.formDataData.teacherId);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //修改轮播图
    upTeacherData() {

      this.loading = true;
      var formDataData = JSON.parse(JSON.stringify(this.formDataData));


      upTeacherData(formDataData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getTeacherDataList(this.formDataData.teacherId);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //添加轮播图
    addTeacherData() {

      this.loading = true;

      var formDataData = JSON.parse(JSON.stringify(this.formDataData))




      addTeacherData(this.formDataData).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.editFormVisibleData = false
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getTeacherDataList(this.formDataData.teacherId);
        } else {
          this.$message.error(res.msg);
        }
      });
    },






  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.upload-demo {
  display: flex;
  flex-direction: row;
}

.upload-demo img {
  width: 140px;
  height: 140px;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/teacher/Teacher.vue